/** @format */

import { formatoTipo, infoTipo, rutaVerOT, rutaCertificar, rutaEditar } from './tipos';
import { milisegundos } from './fechas';

/** Enriquece una orden del endpoint con lo que necesita la UI */
export const mapearOrden = orden => {
	const info = infoTipo(orden.tipo);
	const indice = orden.workOrderIndex;
	return {
		...orden,
		clave: orden.clave || `${orden.lodId}:${indice}`,
		esCertificada: info.esCertificado,
		estado: info.esCertificado ? 'certificada' : 'pendiente',
		tipoEtiqueta: formatoTipo(orden.tipo, orden.emergencia),
		tipoColor: info.color,
		tipoIcono: info.icono,
		urlVer: rutaVerOT(orden.tipo, orden.lodId, indice),
		urlCertificar: rutaCertificar(orden.tipo, orden.lodId, indice),
		urlEditar: rutaEditar(orden.tipo, orden.lodId, indice),
		puedeVer: info.tieneVista,
		puedeCertificar: info.tieneCertificacion && !info.esCertificado,
		puedeEditar: info.tieneCertificacion,
		ordenFechaMs: milisegundos(orden.fechaCertificado || orden.fechaOT || orden.fechaActividad),
	};
};

export const mapearOrdenes = (ordenes = []) => ordenes.map(mapearOrden);

/**
 * Construye las mismas filas a partir de los lodgings ya cargados en Vuex.
 * Es el modo degradado: si el endpoint de busqueda falla, la pantalla sigue
 * mostrando las OT del mes en vez de quedar vacia.
 */
export const construirDesdeLodgings = ({ lodgings = [], places = [], personas = [] }) => {
	const mapaPlaces = new Map(places.map(place => [String(place._id), place]));
	const mapaPersonas = new Map(personas.map(persona => [String(persona._id), persona]));
	const filas = [];

	lodgings.forEach(lod => {
		(lod.workOrder || []).forEach((wo, indice) => {
			if (!wo || !wo.type) return;
			const lugar = mapaPlaces.get(String(lod.place));
			const persona = mapaPersonas.get(String(lod.person));
			filas.push(
				mapearOrden({
					lodId: lod._id,
					workOrderIndex: indice,
					folio: wo.id,
					tipo: wo.type,
					fechaActividad: lod.start,
					fechaOT: wo.date,
					fechaCertificado: wo.fecha,
					horaInicio: wo.startHour,
					horaFin: wo.endHour,
					emergencia: !!(wo.data && wo.data[4]),
					// /timeline/admin no envia las firmas, no se puede saber aqui
					tieneFirma: null,
					tieneFirmaTecnico: null,
					placeId: lod.place,
					personaId: lod.person,
					lugar: lugar ? lugar.name : 'Sin lugar',
					clienteRut: lugar ? lugar.rut : '',
					tecnico: persona
						? `${persona.firstName} ${persona.lastName || ''}`.trim()
						: 'Sin asignar',
					compartida: (lod.foliosCompartidos || []).some(
						folio => String(folio) === String(wo.id)
					),
				})
			);
		});
	});

	return filas.sort((a, b) => b.ordenFechaMs - a.ordenFechaMs);
};
